import React, { createContext, useContext, useEffect } from "react";
import { getHomePageData, homePageType } from "../services/ExploreServices";
import { useAuth } from "./AuthProvider";
import {
  UsePaginatedDataResult,
  usePaginatedData,
} from "./helper/usePaginatedData";

interface PostContextProps {
  exploreState: UsePaginatedDataResult<homePageType>;
}

const ExploreContext = createContext<PostContextProps | undefined>(undefined);

export const ExploreProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const exploreState = usePaginatedData<homePageType>();
  const { user } = useAuth();

  const limit = 16;

  useEffect(() => {
    if (user && exploreState.page > 0)
      exploreState.fetchData(limit, getHomePageData);
    // only rerun on page change ...
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exploreState.page]);

  useEffect(() => {
    exploreState.setPage(0);
    exploreState.setHasMore(true);
    exploreState.setData([]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <ExploreContext.Provider
      value={{
        exploreState,
      }}
    >
      {children}
    </ExploreContext.Provider>
  );
};

export const useExploreContext = () => {
  const context = useContext(ExploreContext);
  if (!context) {
    throw new Error("useExploreContext must be used within a ExploreProvider");
  }
  return context;
};
